import React, { useEffect, useState } from 'react'
import { Spin } from 'antd'
import Talleres from '../../../../service/Talleres'
import TalleresTable from './TalleresAdminTable';

function TalleresAdmin() {
    const [talleres, setTalleres] = useState([]);
    const [cargaInicial, setCargaInicial] = useState(true);

    const getTalleres = async () => {
        try {
            const response = await Talleres.List({ allTalleres: true });
            setTalleres(response?.talleres || []);
        } catch (error) {
            console.error("Error al obtener los talleres:", error);
        } finally {
            setCargaInicial(false);
        }
    }

    useEffect(() => {
        getTalleres();
    }, []);

    // Las acciones de la tabla (activar, pausar, ciclos, fechas) mandan la lista ya
    // actualizada. Antes se ignoraba y se recargaba todo con el spinner de pantalla
    // completa: la tabla se desmontaba y se perdían búsqueda, filtros, página y
    // selección tras cada acción. Ahora se aplica al tiro y se sincroniza por detrás.
    const handleRefresh = (listaActualizada) => {
        if (Array.isArray(listaActualizada)) setTalleres(listaActualizada);
        getTalleres();
    };

    if (cargaInicial) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 400 }}>
                <Spin size="large" />
            </div>
        );
    }

    return <TalleresTable talleres={talleres} onRefresh={handleRefresh} />
}

export default TalleresAdmin
